import { Roles } from "../../../utils/enums";

export interface MenuItemTypes {
    key: string;
    label: string;
    isTitle?: boolean;
    icon?: string;
    url?: string;
    badge?: {
      variant: string;
      text: string;
    };
    parentKey?: string;
    target?: string;
    children?: MenuItemTypes[];
    permission: Array<String>;
    iconIndex:any
  }
  
  const MENU_ITEMS: MenuItemTypes[] = [
    {
      key: "apps-admin",
      label: "Admin",
      isTitle: false,
      icon: "bar-chart",
      url: "/admin",
      permission: [Roles.ADMIN],
      iconIndex: 1,
    },
    {
      key: "apps-ads-dashboard",
      label: "Ads Dashboard",
      isTitle: false,
      icon: "pie-chart",
      url: "/adsDashboard",
      permission: [Roles.ADMIN, Roles.ADSD],
      iconIndex: 19,
    },
    {
      key: "apps-manager",
      label: "Tag Generator",
      isTitle: false,
      icon: "tag",
      url: "/manager",
      permission: [Roles.ADMIN, Roles.TAGGER],
      iconIndex: 2,
    },
    {
      key: "apps-image-tester",
      label: "Image Testser",
      isTitle: false,
      icon: "shield",
      url: "/imageTester",
      permission: [Roles.ADMIN, Roles.TAGGER, Roles.TESTER],
      iconIndex: 3,
    },
    // {
    //   key: "apps-GLU",
    //   label: "GLU",
    //   isTitle: false,
    //   icon: "mail",
    //   url: "/GLU",
    //   permission: [Roles.ADMIN, Roles.GLU],
    //   iconIndex: 4,
    // },
    {
      key: "apps-targeting",
      label: "Targeting Config",
      isTitle: false,
      icon: "target",
      url: "/targeting",
      permission: [Roles.ADMIN, Roles.SEGMENT],
      iconIndex: 5,
    },
    {
      key: "apps-op-reporting",
      label: "OP Reporting",
      isTitle: false,
      icon: "file",
      url: "/reporter",
      permission: [Roles.ADMIN, Roles.OPREPORTING],
      iconIndex: 6,
    },
    // {
    //   key: "apps-s3Loader",
    //   label: "S3-UPLOADER",
    //   isTitle: false,
    //   icon: "message-square",
    //   url: "/s3Loader",
    //   permission: [Roles.ADMIN, Roles.SEGMENT]
    // }
    // {
    //   key: "apps-JSC",
    //   label: "JSC",
    //   isTitle: false,
    //   icon: "code",
    //   url: "/jsConfig",
    //   permission: [Roles.ADMIN, Roles.SPECIAL, Roles.JS_CONFIG],
    //   iconIndex: 7,
    // },
    {
      key: "apps-campaigns",
      label: "Campaigns",
      isTitle: false,
      icon: "file-plus",
      url: "/Campaigns",
      permission: [Roles.ADMIN, Roles.CAMP],
      iconIndex: 8,
    },
    {
      key: "apps-cTargeting",
      label: "Upload Audience",
      isTitle: false,
      icon: "target",
      url: "/uploadAudience",
      permission: [Roles.ADMIN, Roles.CTARGET],
      iconIndex: 9,
    },
    {
      key: "apps-eventsLogger",
      label: "Events Logger",
      isTitle: false,
      icon: "terminal",
      url: "/eventsLogger",
      permission: [Roles.ADMIN, Roles.CLOGGER],
      iconIndex: 10,
    },
    {
      key: "apps-adsImpressions",
      label: "Ads Impressions",
      isTitle: false,
      icon: "bookmark",
      url: "/adsImpressions",
      permission: [Roles.ADMIN, Roles.AIMP],
      iconIndex: 11,
    },
    {
      key: "apps-ipFiltering",
      label: "Prod IP Filtering",
      isTitle: false,
      icon: "filter",
      url: "/ipFiltering",
      permission: [Roles.ADMIN, Roles.PROD_FILTERING],
      iconIndex: 12,
    },
    {
      key: "apps-ipFilteringDemo",
      label: "Demo IP Filtering",
      isTitle: false,
      icon: "align-center",
      url: "/ipFilteringDemo",
      permission: [Roles.ADMIN, Roles.DEMO_FILTERING],
      iconIndex: 13,
    },
    {
      key: "apps-opCreativeUpload",
      label: "OP Creative Upload",
      isTitle: false,
      icon: "image",
      url: "/opCreativeUpload",
      permission: [Roles.ADMIN, Roles.OP_CREATIVE_UPLOAD],
      iconIndex: 14,
    },
    {
      key: "apps-html5-upload",
      label: "HTML5 Generator",
      isTitle: false,
      icon: "grid",
      url: "/html5_generator",
      permission: [Roles.ADMIN, Roles.HTML5_GENERATOR],
      iconIndex: 15,
    },
    {
      key: "apps-bid-requests",
      label: "Bid Requests",
      isTitle: false,
      icon: "database",
      url: "/bidRequests",
      permission: [Roles.ADMIN, Roles.BID_REQUESTS],
      iconIndex: 16,
    },
    {
      key: "apps-realtime-monitor",
      label: "Realtime Monitor",
      isTitle: false,
      icon: "server",
      url: "/realtimeMonitor",
      permission: [Roles.ADMIN, Roles.REALTIME_MONITOR],
      iconIndex: 20,
    },
    {
      key: "apps-user-management",
      label: "User Management",
      isTitle: false,
      icon: "users",
      url: "/userManagement",
      permission: [Roles.ADMIN,Roles.SUPER_USER],
      iconIndex: 17,
    },
    {
      key: "apps-creativeUpload",
      label: "Creative Upload",
      isTitle: false,
      icon: "image",
      url: "/creativeUpload",
      permission: [Roles.ADMIN, Roles.CREATIVE_UPLOAD],
      iconIndex: 14,
    },
    {
      key: "apps-userInfoNG",
      label: "User Info",
      isTitle: false,
      icon: "user",
      url: "/userInfo",
      permission: [Roles.ADMIN, Roles.USER_INFO_NG],
      iconIndex: 18,
    },
    {
      key: "apps-userInfo",
      label: "User Sync Info 1",
      isTitle: false,
      icon: "user",
      url: "/userSyncInfo1",
      permission: [Roles.ADMIN, Roles.USER_INFO],
      iconIndex: 18,
    },
    {
      key: "apps-userInfoV2",
      label: "User API Info 2",
      isTitle: false,
      icon: "user",
      url: "/userAPIInfo2",
      permission: [Roles.ADMIN, Roles.USER_INFO_V2],
      iconIndex: 18,
    },
    {
      key: "apps-yandex",
      label: "Yandex",
      isTitle: false,
      icon: "align-justify",
      url: "/yandex",
      permission: [Roles.ADMIN, Roles.YANDEX],
      iconIndex: 21,
    },
    
  ];
  
  export { MENU_ITEMS };
  